import React from 'react';
import { createBillingAddress, updateBillingAddress,
  createVatAddress, updateVatProfile } from '../../app-main/actions/fee-profile';
import { SubmissionError } from 'redux-form';
import { omit, pick, get } from 'lodash';
import { FormattedMessage } from 'react-intl';

const onSubmitTaxRegistrationForm = (values = {}, dispatch, props) => {
  const { _id: feeProfileId, ssoId } = values;
  const { accessToken, billingAddress, addressOptionSelected,
  isProvincial, isEdit, federalVatProfileId, subRegionVatProfileId } = props;

  const useBillingAddress = 'same-as-billing' === addressOptionSelected;
  const vatPercentValueExists = parseFloat(get(values, 'vat_percent')) >= 0;
  const vatPercent = parseFloat(get(values, 'vat_percent', 0), 10);

  const billingAddressFields = useBillingAddress ?
    pick(billingAddress[0],
      ['country', 'state', 'street', 'city', 'zip', 'unit']) : {};

  const payloadValues = useBillingAddress ?
    omit(values, ['country', 'state', 'street', 'city', 'zip', 'unit', 'addressChoice']) : values;

  const payload = {
    ...payloadValues,
    ...billingAddressFields,
    ...(vatPercentValueExists && {vat_percent: vatPercent / 100}),
    type: 'VAT',
    sso_id: ssoId,
    ...(isProvincial && { is_subregion: true })
  };

  if (isEdit) {
    const feeProfileId = isProvincial ? subRegionVatProfileId : federalVatProfileId;

    return dispatch(updateVatProfile(accessToken, ssoId, feeProfileId, payload))
      .then(() => {
        window.location.href = '/account/taxes/submitted';
        return null;
      })
      .catch((err) => {
        throw new SubmissionError({
          _error: <FormattedMessage
            id="hosting.on_submit_tax_registration_form.error_message"
            defaultMessage="Submission failed. Please refresh and try again." />
        });
      });
  } else {
    return dispatch(createVatAddress(accessToken, ssoId, payload))
      .then(() => {
        window.location.href = '/account/taxes/submitted';
        return null;
      })
      .catch((err) => {
        throw new SubmissionError({
          _error: <FormattedMessage
            id="hosting.on_submit_tax_registration_form.error_message"
            defaultMessage="Submission failed. Please refresh and try again." />
        });
      });
  }
};

export default onSubmitTaxRegistrationForm;
